import React from "react";
import PropTypes from "prop-types";
import { Grid, Paper } from "@material-ui/core";

import TarjetaOpcion from "./TarjetaOpcion";

const GridOpciones = ({ opciones, onSeleccionar }) => (
  <Grid
    container
    direction="row"
    justifyContent="center"
    style={{ paddingTop: 30 }}
  >
    <Grid item xs={12} sm={12} md={10} lg={8}>
      <Grid container direction="row" justifyContent="center">
        {opciones.map((opcion) => (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            key={opcion.codigo}
            style={{ padding: "2% 2% 0% 2%" }}
            onClick={() => onSeleccionar(opcion)}
          >
            <Paper
              elevation={8}
              style={{ borderRadius: "12px", overflow: "hidden" }}
            >
              <TarjetaOpcion opcion={opcion} />
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Grid>
  </Grid>
);

GridOpciones.propTypes = {
  opciones: PropTypes.array.isRequired,
  onSeleccionar: PropTypes.func.isRequired,
};

export default GridOpciones;
